import { Common, SimpleGenEq } from '../genHelper';

export const Multiplication = {
  simple: (times: number[], min = 0, max = 10) => {
    return (r: any) => {
      const a = times[r.next(times.length)];
      const b = r.NN(1, min, max)[0];
      return [b, a];
    };
  },

  mulDigits: (digitsX: number, digitsY: number) => {
    return (r: any) => {
      const x = r.digitsInt32(digitsX);
      const y = r.digitsInt32(digitsY);
      return [x, y];
    };
  },

  divDigits: (digitsZ: number, digitsX: number) => {
    return (r: any) => {
      const z = r.digitsInt32(digitsZ);
      const x = r.digitsInt32(digitsX);
      const d = Math.floor(z / x);
      return [d, x];
    };
  },

  advanced: () => {
    return (r: any) => {
      const a = 2 + r.next(8); // 2-9
      const b = 2 + r.next(8); // 2-9
      return [a, b];
    };
  },
};

export class Math_Multiplication__1 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([1])), 'Math_Multiplication__1');
  }
}
export class Math_Multiplication__2 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([2])), 'Math_Multiplication__2');
  }
}
export class Math_Multiplication__3 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([3])), 'Math_Multiplication__3');
  }
}
export class Math_Multiplication__4 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([4])), 'Math_Multiplication__4');
  }
}
export class Math_Multiplication__5 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([5])), 'Math_Multiplication__5');
  }
}
export class Math_Multiplication__6 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([6])), 'Math_Multiplication__6');
  }
}
export class Math_Multiplication__7 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([7])), 'Math_Multiplication__7');
  }
}
export class Math_Multiplication__8 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([8])), 'Math_Multiplication__8');
  }
}
export class Math_Multiplication__9 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([9])), 'Math_Multiplication__9');
  }
}
export class Math_Multiplication__10 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([10])), 'Math_Multiplication__10');
  }
}
export class Math_Multiplication__11 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([11])), 'Math_Multiplication__11');
  }
}
export class Math_Multiplication__12 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([12])), 'Math_Multiplication__12');
  }
}
export class Math_Multiplication__13 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([13])), 'Math_Multiplication__13');
  }
}
export class Math_Multiplication__14 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([14])), 'Math_Multiplication__14');
  }
}
export class Math_Multiplication__15 extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.simple([15])), 'Math_Multiplication__15');
  }
}

// TimesTables
export class Math_Multiplication_TimesTables__All extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.simple([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])),
      'Math_Multiplication_TimesTables__All'
    );
  }
}
export class Math_Multiplication_TimesTables__Harder extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.advanced()), 'Math_Multiplication_TimesTables__Harder');
  }
}
export class Math_Multiplication_TimesTables__Mini extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.simple([2, 3, 4], 1, 5)),
      'Math_Multiplication_TimesTables__Mini'
    );
  }
}

// Repeated Addition
export class Math_Multiplication_RepeatedAddition__1 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([1], 1)),
      'Math_Multiplication_RepeatedAddition__1'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__2 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([2], 1)),
      'Math_Multiplication_RepeatedAddition__2'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__3 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([3], 1)),
      'Math_Multiplication_RepeatedAddition__3'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__4 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([4], 1)),
      'Math_Multiplication_RepeatedAddition__4'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__5 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([5], 1)),
      'Math_Multiplication_RepeatedAddition__5'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__6 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([6], 1)),
      'Math_Multiplication_RepeatedAddition__6'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__7 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([7], 1)),
      'Math_Multiplication_RepeatedAddition__7'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__8 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([8], 1)),
      'Math_Multiplication_RepeatedAddition__8'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__9 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([9], 1)),
      'Math_Multiplication_RepeatedAddition__9'
    );
  }
}
export class Math_Multiplication_RepeatedAddition__10 extends SimpleGenEq {
  constructor() {
    super(
      Common.multiplyAddition(Multiplication.simple([10], 1)),
      'Math_Multiplication_RepeatedAddition__10'
    );
  }
}

// Digits
export class Math_Multiplication_Digits__XXXXXXX__Y extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(7, 1)),
      'Math_Multiplication_Digits__XXXXXXX__Y'
    );
  }
}
export class Math_Multiplication_Digits__XXXXXXX__YY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(7, 2)),
      'Math_Multiplication_Digits__XXXXXXX__YY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXXXX__YYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(7, 3)),
      'Math_Multiplication_Digits__XXXXXXX__YYY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(7, 4)),
      'Math_Multiplication_Digits__XXXXXXX__YYYY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(6, 1)), 'Math_Multiplication_Digits__XXXXXX__Y');
  }
}
export class Math_Multiplication_Digits__XXXXXX__YY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(6, 2)),
      'Math_Multiplication_Digits__XXXXXX__YY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXXX__YYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(6, 3)),
      'Math_Multiplication_Digits__XXXXXX__YYY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(6, 4)),
      'Math_Multiplication_Digits__XXXXXX__YYYY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(5, 1)), 'Math_Multiplication_Digits__XXXXX__Y');
  }
}
export class Math_Multiplication_Digits__XXXXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(5, 2)), 'Math_Multiplication_Digits__XXXXX__YY');
  }
}
export class Math_Multiplication_Digits__XXXXX__YYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(5, 3)),
      'Math_Multiplication_Digits__XXXXX__YYY'
    );
  }
}
export class Math_Multiplication_Digits__XXXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(5, 4)),
      'Math_Multiplication_Digits__XXXXX__YYYY'
    );
  }
}
export class Math_Multiplication_Digits__XXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(4, 1)), 'Math_Multiplication_Digits__XXXX__Y');
  }
}
export class Math_Multiplication_Digits__XXXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(4, 2)), 'Math_Multiplication_Digits__XXXX__YY');
  }
}
export class Math_Multiplication_Digits__XXXX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(4, 3)), 'Math_Multiplication_Digits__XXXX__YYY');
  }
}
export class Math_Multiplication_Digits__XXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(
      Common.multiply(Multiplication.mulDigits(4, 4)),
      'Math_Multiplication_Digits__XXXX__YYYY'
    );
  }
}
export class Math_Multiplication_Digits__XXX__YYYY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(3, 4)), 'Math_Multiplication_Digits__XXX__YYYY');
  }
}
export class Math_Multiplication_Digits__XXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(3, 1)), 'Math_Multiplication_Digits__XXX__Y');
  }
}
export class Math_Multiplication_Digits__XXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(3, 2)), 'Math_Multiplication_Digits__XXX__YY');
  }
}
export class Math_Multiplication_Digits__XXX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(3, 3)), 'Math_Multiplication_Digits__XXX__YYY');
  }
}
export class Math_Multiplication_Digits__XX__Y extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(2, 1)), 'Math_Multiplication_Digits__XX__Y');
  }
}
export class Math_Multiplication_Digits__XX__YY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(2, 2)), 'Math_Multiplication_Digits__XX__YY');
  }
}
export class Math_Multiplication_Digits__XX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(2, 3)), 'Math_Multiplication_Digits__XX__YYY');
  }
}
export class Math_Multiplication_Digits__XX__YYYY extends SimpleGenEq {
  constructor() {
    super(Common.multiply(Multiplication.mulDigits(2, 4)), 'Math_Multiplication_Digits__XX__YYYY');
  }
}
